import React from "react";
import { connect } from "react-redux";
import ProgressBar from "react-bootstrap/ProgressBar";

import { nutritionJournalList } from "./helper";

const JournalCrads = ({ data, goal }) => {
	const summaryData = nutritionJournalList
		? nutritionJournalList.map((item) => {
				const percentage = data[item.id] && goal[item.id] ? (data[item.id] / goal[item.id]) * 100 : 0;
				return {
					...item,
					value: data[item.id],
					goal: goal[item.id],
					percentage: isFinite(percentage) ? percentage : 0
				};
		  })
		: [];

	const caloriePercent = (data, goal) => {
		return data && goal ? (data / goal) * 100 : 0;
	};

	return (
		<div className="row">
			<div className="col-12">
				<div className="row pb-4">
					{summaryData &&
						summaryData.map((item, index) => {
							return (
								<div className="col-3 h-100" key={index}>
									<div className="card card-primary p-4 border-0 mt-5">
										<div
											className="journal-card-icon"
											style={{
												backgroundImage: `linear-gradient(to bottom right, ${item.color[0]}, ${
													item.color[1]
												})`,
												boxShadow: `${item.shadow}`
											}}>
											<i className={item.icon} />
										</div>
										<div className="d-flex align-items-center">
											<h1 className="mr-1" style={{ color: item.text_color }}>
												{item.value ? item.value : "0"} /{" "}
											</h1>
											<h4 style={{ color: item.text_color }}> {item.goal ? item.goal : "0"}</h4>
										</div>
										<p className="text-uppercase mb-0">{item.label}</p>

										<div className=" row align-items-center ">
											<div className="col-9">
												<ProgressBar
													className={`w-100 progress-${item.color[1].replace("#", "")}`}
													now={item.percentage}
												/>
											</div>
											<div className="col-3" style={{ whiteSpace: "nowrap" }}>
												{Math.round(item.percentage) > 100 ? "100" : Math.round(item.percentage)} %
											</div>
										</div>
									</div>
								</div>
							);
						})}

					<div className="col-3 h-100">
						<div className="card card-primary mt-5 d-flex justify-content-center align-items-center p-4 border-0 calorie_card">
							<div className="row mb-1">
								<div className="col-8 text-nowrap">
									<div className="d-flex align-items-center">
										{/* <h1> {data.nut ? data.nut : "0"} / </h1> */}
										<h1 className="mr-1" style={{ color: "#fff" }}>
											{data.calories ? data.calories : 0} /
										</h1>
										<h4 style={{ color: "#fff" }}> {goal.calories ? goal.calories : 0} </h4>
									</div>
									<p className="text-uppercase">total calories</p>
									<ProgressBar
										className="w-100 progress-FFFFFF"
										now={caloriePercent(data.calories, goal.calories)}
									/>
								</div>
								<div className="col-4">
									<div
										className="icon-wrapper mb-2"
										style={{
											backgroundImage: `linear-gradient(to bottom right,#3698C3, #2C91C1)`
										}}>
										<i className="icon icon-calories xl-icon" />
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

const mapDispatchToProps = {};

export default connect(
	null,
	mapDispatchToProps
)(JournalCrads);
